import { Button, Modal } from 'antd';

const WizardUpdateConfirmModal = ({ open, mode, onOk, onCancel }) => (
  <Modal
    title="Ponavljajoča transakcija - Potrdi spremembe"
    open={open}
    onCancel={onCancel}
    footer={[
      <Button key="cancel" onClick={onCancel}>Prekliči</Button>,
      <Button key="ok" type="primary" onClick={onOk}>Potrdi</Button>,
    ]}
  >
    <p>
      {mode === 'all'
        ? 'Spremembe bodo uporabljene za izbrane ponovitve.'
        : 'Spremembe bodo uporabljene SAMO za to ponovitev.'}
    </p>
  </Modal>
);

export default WizardUpdateConfirmModal;
